import { defineStore } from "pinia";
import * as storeResetHelper from "@/shared/storeResetHelper";
import { useUserStore } from "@/shared/store/user";
import Vue from "vue";

export const useRootStore = defineStore("root", {
    actions: {
        setupRoot () {
            const userStore = useUserStore();
            userStore.setValidGroups(Vue.prototype.$bendAppOptions.validGroups);
            userStore.setSite(Vue.prototype.$bendAppOptions.site);
        },
        resetState () {
            storeResetHelper.resetAllPiniaStores();
            this.setupRoot();
        },
        filteredStateReset ({ moduleKeys }: { moduleKeys: string[] }) {
            const isSelectedModuleKey = testKey => moduleKeys.some(moduleKey => moduleKey === testKey);
            storeResetHelper.filteredReset(isSelectedModuleKey);

        }
    }
});


